import React from 'react';
import { connect } from 'react-redux';
import I18n from 'apps/new-web/views/components/i18n';
import PropTypes from 'prop-types';
import Time from 'apps/new-web/views/components/time-by-country';

const Overview = ({ sharedWorkout: { activityLog, workout } }) => {
  return (
    <div className="overview">
      <h4 className="header-default"><I18n desc="A description of the completed workout.">Overview</I18n></h4>
      <p>{ workout.description }</p>
      { activityLog &&
        <React.Fragment>
          <h3 className="header-completed"><I18n desc="Information on when the workout was completed.">Completed</I18n></h3>
          <Time
            dateTime={ activityLog.end }
            time12hrFormat="h:mm aaaa, MMM. d, yyyy"
            time24hrFormat="kk:mm, MMM. d, yyyy"
          />
        </React.Fragment>
      }
    </div>
  );
};

Overview.propTypes = {
  activityLog: PropTypes.object,
  sharedWorkout: PropTypes.object.isRequired
};

const ConnectedOverview = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout
  };
})(Overview);

export default ConnectedOverview;
